
import {  createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  SetTenantStateActionPayload,
  TenantState,
} from "../../entities/Tenant";

const initialState: TenantState = {
  data: {
    credentials: null,
  },
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenantState: (
      state: TenantState,
      action: PayloadAction<SetTenantStateActionPayload>,
    ) => {
      state.data = action.payload;
    },
  },
});

export const { setTenantState } = tenantSlice.actions;

export default tenantSlice.reducer;
